import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { ModuleFilterActionTypes, ModuleFilterActions } from '../actions/module-filter.actions';


@Injectable()
export class ModuleFilterEffects {
  private actions$ = inject(Actions);
  loadModuleFilters$ = createEffect(() => this.actions$.pipe(
    ofType(ModuleFilterActionTypes.LoadModuleFilters),
    /** An EMPTY observable only emits completion. Replace with your own observable API request */
    concatMap(() => EMPTY)
  ), { dispatch: false });


  constructor() {}

}
